<template>
  <div class="bookprice-page">
    <div
      style="position: absolute; top: 50%; left: 52%; width: 10%; z-index: 2"
      v-show="loadData == true || loadExport == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card class="mktops-tab">
          <md-card-content>
            <div style="padding-top: 3px; height: 37px">
              <div
                :class="valueTab == 'ALL' ? 'tab-active' : 'tab-in-active'"
                @click="onClickTab('ALL')"
                style="margin-left: 20px"
              >
                ALL
                <span class="tab-chip -chipgray">{{ countDataAll }}</span>
              </div>
              <div
                :class="valueTab == 'UPCOMING' ? 'tab-active' : 'tab-in-active'"
                @click="onClickTab('UPCOMING')"
              >
                UPCOMING
                <span class="tab-chip -primary">{{ countDataUpcoming }}</span>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item" style="width: -webkit-fill-available">
        <md-card class="tab-table">
          <md-card-content>
            <div class="md-layout">
              <div
                class="
                  md-layout-item
                  md-large-size-20
                  md-medium-size-20
                  md-small-size-25
                "
              >
                <div class="pricing-head mktops-subheader-filter">
                  <md-field class="box">
                    <md-select v-model="slcSearch" id="select-price-unit">
                      <md-option
                        v-for="(item, index) in status"
                        :key="index"
                        :value="index"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>
              </div>

              <div
                class="
                  md-layout-item
                  md-large-size-35
                  md-medium-size-35
                  md-small-size-35
                "
              >
                <md-field class="md-search-box">
                  <i
                    class="md-icon material-icons"
                    style="margin-top: 6px; cursor: pointer"
                    :title="titleSearch"
                    @click="selectSearch"
                    >find_replace</i
                  >
                  <md-input
                    type="text"
                    :placeholder="placeholderSearch"
                    style="padding-right: 8px"
                    v-model="searchKeyword"
                    @input="onChangeSearch()"
                  ></md-input>
                </md-field>
                <md-button
                  class="md-icon-button"
                  title="Add Filters"
                  @click="filterData"
                >
                  <md-icon>filter_list</md-icon>
                </md-button>
              </div>
              <div
                class="
                  md-layout-item
                  md-large-size-45
                  md-medium-size-45
                  md-small-size-40
                  layout-flex-end
                "
                style="padding-right: 20px"
              >
                <div>
                  <md-button
                    v-show="isExport"
                    class="md-raised md-primary"
                    style="
                      background-color: #d84710;
                      height: 32px;
                      margin-right: 0px;
                    "
                    @click="export_excel"
                  >
                    Excel selected
                  </md-button>
                </div>
                <!-- <div>
                  <md-button class="md-raised md-primary -import">
                    <i class="md-icon material-icons">add</i>IMPORT
                  </md-button>
                </div> -->
              </div>
            </div>

            <div
              class="md-layout filter-chips"
              v-if="
                vChipsFilter.length > 0 ||
                bookPrice !== null ||
                (selectedCustomer && selectedCustomer.id !== undefined)
              "
            >
              <div>
                <span v-if="bookPrice !== null" class="tab-chip -primary">
                  <label> GROUP. [{{ bookPrice.code }}]</label>
                  <span
                    class="tab-chip -delete"
                    @click="deleteDataSelected('groupbook')"
                  >
                    <i class="material-icons">close</i>
                  </span>
                </span>

                <span
                  v-if="selectedCustomer && selectedCustomer.id !== undefined"
                  class="tab-chip -primary"
                >
                  <label :title="selectedCustomer.label">
                    GROUP. [{{ selectedCustomer.id }}]</label
                  >
                  <span
                    class="tab-chip -delete"
                    @click="deleteDataSelected('customer')"
                  >
                    <i class="material-icons">close</i>
                  </span>
                </span>
              </div>

              <div v-for="(items, idx) in vChipsFilter" :key="items.keyId">
                <span
                  v-if="items.code === undefined"
                  class="tab-chip"
                  style="background-color: #727272; margin-right: 5px"
                >
                  <label :title="dataCompareCustomer[idx].label"
                    >GROUP. [{{ items }}]</label
                  >
                  <span
                    class="tab-chip -delete -colorgray"
                    @click="deleteFilter(items, idx)"
                  >
                    <i class="material-icons">close</i>
                  </span>
                </span>

                <span v-else class="tab-chip -chiplightgray">
                  <label :title="items.title">{{ displayFilter(items) }}</label>
                  <span
                    class="tab-chip -delete -colorgray"
                    @click="deleteFilter(items, idx)"
                  >
                    <i class="material-icons">close</i>
                  </span>
                </span>
              </div>
            </div>

            <!-- TABLE -->
            <!-- v-if="vChipsFilter.length === 0" -->
            <div
              v-if="bookPrice === null && selectedCustomer.id === undefined"
              style="
                display: block;
                text-align: center;
                color: #a5a5a5;
                height: calc(100vmin - 179px);
              "
            >
              <div style="padding-top: 30px">
                Please select condition search!!
              </div>
            </div>
            <div v-else id="table-bookprice-list">
              <!-- HEAD -->
              <div id="divHeadList">
                <div style="width: 6%">Code</div>
                <!-- <div :style="slcSearch == 0 ? 'width: 45%' : 'width: 39%'"> -->
                <div :style="setStyle(slcSearch)">Item Name</div>
                <div v-show="slcSearch == 1" style="width: 6%">Unit</div>
                <div style="width: 7.2%" class="-text-right">Cost</div>
                <div
                  style="width: 7.2%"
                  class="-text-right"
                  title="ราคาส่ง ( ไม่รวม VAT )"
                >
                  A3
                </div>
                <div
                  style="width: 7.2%"
                  class="-text-right"
                  title="ราคาขายส่ง หักส่วนลดสูงสุด"
                >
                  C0
                </div>
                <div
                  style="width: 7.2%"
                  class="-text-right"
                  title="ราคาปลีกแนะนำ(ไม่รวมVAT)"
                >
                  SS
                </div>
                <div
                  v-if="bookPrice !== null"
                  style="width: 7.2%"
                  class="-text-right"
                  :title="bookPrice.desc"
                >
                  {{ bookPrice.code }}
                </div>
                <div
                  v-if="selectedCustomer && selectedCustomer.id !== undefined"
                  style="width: 7.2%; cursor: context-menu"
                  class="-text-right"
                  :title="
                    labelTitle(selectedCustomer.id, selectedCustomer.label)
                  "
                >
                  {{ selectedCustomer.id }}
                </div>
                <!-- <div
                  v-show="
                    tbBookpriceList['customer'] &&
                      tbBookpriceList['customer'].id !== undefined
                  "
                  style="width: 7.2%"
                  class="-text-right"
                >
                  {{
                    tbBookpriceList["customer"] &&
                    tbBookpriceList["customer"].id !== undefined
                      ? tbBookpriceList["customer"].id
                      : ""
                  }}
                </div> -->

                <!-- COMPARE -->
                <div
                  v-show="customer1 !== ''"
                  style="width: 7.2%; cursor: context-menu"
                  class="-text-right"
                  :title="labelTitle(customer1, customer1Title)"
                >
                  {{ customer1 }}
                </div>
                <div
                  v-show="customer2 !== ''"
                  style="width: 7.2%; cursor: context-menu"
                  class="-text-right"
                  :title="labelTitle(customer2, customer2Title)"
                >
                  {{ customer2 }}
                </div>
                <div
                  v-show="customer3 !== ''"
                  style="width: 7.2%; cursor: context-menu"
                  class="-text-right"
                  :title="labelTitle(customer3, customer3Title)"
                >
                  {{ customer3 }}
                </div>

                <div style="width: 7.7%" class="-text-center">Eff. Date</div>
                <div style="width: 6.5%" class="-text-center">Exp. Date</div>
                <div style="width: 2%"></div>
              </div>

              <!-- BODY -->
              <div
                id="divBodyList"
                :class="
                  vChipsFilter.length > 0 ||
                  bookPrice !== null ||
                  (selectedCustomer && selectedCustomer.id !== undefined)
                    ? 'de-height'
                    : 'cal-height'
                "
                @scroll="handleScroll"
              >
                <div
                  v-show="tbBookpriceList.length === 0"
                  :class="'row-bg-gray'"
                  style="display: block; text-align: center; font-size: 14px"
                >
                  No data in table.
                </div>

                <div
                  :class="
                    rIndex % 2 == 1
                      ? 'row-bg-gray'
                      : 'main-row-bg-gray row-bg-gray'
                  "
                  v-for="(item, rIndex) in tbBookpriceList"
                  :key="rIndex"
                >
                  <div id="mainRows">
                    <!-- column Code -->
                    <div :style="{ width: '6%' }">
                      <div style="font-size: 13px; padding-left: 2px">
                        {{ item.code }}
                      </div>
                      <div
                        v-if="slcSearch == 0"
                        style="
                          font-size: 11px;
                          font-style: italic;
                          font-family: kanit;
                        "
                      >
                        {{ item.selling_um_title }} ({{ item.selling_um_conv }})
                      </div>
                    </div>

                    <!-- column Name -->
                    <div
                      style="font-size: 14px; font-weight: 300"
                      :style="setStyle(slcSearch)"
                      class="nowrap-title"
                    >
                      <span :title="item.title_th">{{ item.title_th }}</span>
                    </div>

                    <!-- column Unit -->
                    <div
                      v-show="slcSearch == 1"
                      style="width: 6%; font-weight: 300; font-family: kanit"
                    >
                      <div
                        v-if="item.selling_um_conv"
                        style="
                          font-size: 14px;
                          padding-left: 0px;
                          padding-right: 0px;
                        "
                      >
                        {{ item.selling_um_title }} ({{ item.selling_um_conv }})
                      </div>
                      <div
                        v-else
                        style="
                          font-size: 14px;
                          padding-left: 0px;
                          padding-right: 0px;
                        "
                      >
                        {{ item.selling_um_title }}
                      </div>
                      <div
                        style="
                          font-size: 12px;
                          padding-left: 0px;
                          padding-right: 0px;
                        "
                      >
                        {{ item.stock_um_title }}
                      </div>
                    </div>

                    <!-- column Cost -->
                    <div style="width: 7.2%" class="-text-right">
                      <div v-if="item.cost && item.cost != ''">
                        {{ showPoint(formatNumber(item.cost, 2), "front") }}
                        <span style="font-size: 11px">{{
                          showPoint(formatNumber(item.cost, 2), "behind")
                        }}</span>
                      </div>
                      <div v-show="slcSearch == 1" class="-percent">
                        {{ formatNumber(item.cost, 2) }}
                      </div>
                    </div>

                    <!-- column A3 -->
                    <div style="width: 7.2%" class="-text-right">
                      <div
                        v-if="
                          item.selling_conv_price === undefined ||
                          item.selling_conv_price.A3 == null ||
                          item.selling_conv_price.A3 === ''
                        "
                        style="visibility: hidden"
                      >
                        -
                        <!-- {{
                          showPoint(
                            formatNumber(item.selling_conv_price.A3, 2),
                            "front"
                          )
                        }}
                        <span style="font-size:11px">{{
                          showPoint(
                            formatNumber(item.selling_conv_price.A3, 2),
                            "behind"
                          )
                        }}</span> -->
                      </div>
                      <!-- <div v-else style="visibility: hidden;">-</div> -->
                      <div v-else style="display: inline">
                        {{
                          showPoint(
                            formatNumber(item.selling_conv_price.A3, 2),
                            "front"
                          )
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(item.selling_conv_price.A3, 2),
                            "behind"
                          )
                        }}</span>
                      </div>
                      <div
                        v-if="slcSearch == 1"
                        :class="item.price.A3 < 0 ? '-bgred' : '-percent'"
                      >
                        {{ formatNumber(item.price.A3, 2) }}
                      </div>
                    </div>

                    <!-- column C0 -->
                    <div style="width: 7.2%" class="-text-right">
                      <div
                        v-if="
                          item.selling_conv_price === undefined ||
                          item.selling_conv_price.C0 == null ||
                          item.selling_conv_price.C0 === ''
                        "
                        style="visibility: hidden"
                      >
                        -
                        <!-- {{
                          showPoint(
                            formatNumber(item.selling_conv_price.C0, 2),
                            "front"
                          )
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(item.selling_conv_price.C0, 2),
                            "behind"
                          )
                        }}</span> -->
                      </div>
                      <!-- <div v-else style="visibility: hidden">-</div> -->
                      <div v-else style="display: inline">
                        {{
                          showPoint(
                            formatNumber(item.selling_conv_price.C0, 2),
                            "front"
                          )
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(item.selling_conv_price.C0, 2),
                            "behind"
                          )
                        }}</span>
                      </div>
                      <div
                        v-if="slcSearch == 0"
                        :class="classPercent(item.selling_conv_price, 2, 'C0')"
                      >
                        {{ calPercent(item.selling_conv_price, 2, "C0") }}%
                      </div>
                      <div
                        v-else-if="slcSearch == 1"
                        :class="
                          item.selling_conv_price.C0 < 0 ? '-bgred' : '-percent'
                        "
                      >
                        {{ formatNumber(item.selling_conv_price.C0, 2) }}
                      </div>
                    </div>

                    <!-- column SS -->
                    <div style="width: 7.2%" class="-text-right">
                      <div
                        v-if="
                          item.selling_conv_price === undefined ||
                          item.selling_conv_price.SS == null ||
                          item.selling_conv_price.SS === ''
                        "
                        style="visibility: hidden"
                      >
                        -
                        <!-- {{
                          showPoint(
                            formatNumber(item.selling_conv_price.SS, 2),
                            "front"
                          )
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(item.selling_conv_price.SS, 2),
                            "behind"
                          )
                        }}</span> -->
                      </div>
                      <!-- <div v-else style="visibility: hidden">-</div> -->
                      <div v-else style="display: inline">
                        {{
                          showPoint(
                            formatNumber(item.selling_conv_price.SS, 2),
                            "front"
                          )
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(item.selling_conv_price.SS, 2),
                            "behind"
                          )
                        }}</span>
                      </div>
                      <div
                        v-if="slcSearch == 0"
                        :class="classPercent(item.selling_conv_price, 2, 'SS')"
                      >
                        {{ calPercent(item.selling_conv_price, 2, "SS") }}%
                      </div>
                      <div
                        v-else-if="slcSearch == 1"
                        :class="
                          item.selling_conv_price.SS < 0 ? '-bgred' : '-percent'
                        "
                      >
                        {{ formatNumber(item.selling_conv_price.SS, 2) }}
                      </div>
                    </div>

                    <!-- column Book Code -->
                    <div
                      v-if="bookPrice !== null"
                      style="width: 7.2%"
                      class="-text-right"
                    >
                      <div
                        v-if="
                          item.selling_conv_price === undefined ||
                          item.selling_conv_price[bookPrice.code] == null ||
                          item.selling_conv_price[bookPrice.code] === ''
                        "
                        style="visibility: hidden"
                      >
                        -
                        <!-- {{
                          showPoint(
                            formatNumber(
                              item.selling_conv_price[bookPrice.code],
                              2
                            ),
                            "front"
                          )
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(
                              item.selling_conv_price[bookPrice.code],
                              2
                            ),
                            "behind"
                          )
                        }}</span> -->
                      </div>
                      <!-- <div v-else style="visibility: hidden">-</div> -->
                      <div v-else style="display: inline">
                        {{
                          showPoint(
                            formatNumber(
                              item.selling_conv_price[bookPrice.code],
                              2
                            ),
                            "front"
                          )
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(
                              item.selling_conv_price[bookPrice.code],
                              2
                            ),
                            "behind"
                          )
                        }}</span>
                      </div>
                      <div
                        v-if="slcSearch == 0"
                        :class="
                          classPercent(item.selling_conv_price, 2, 'bookcode')
                        "
                      >
                        {{
                          calPercent(item.selling_conv_price, 2, "bookcode")
                        }}%
                      </div>
                      <div
                        v-else-if="slcSearch == 1"
                        :class="item.price.B1 < 0 ? '-bgred' : '-percent'"
                      >
                        {{ formatNumber(item.price[bookPrice.code], 2) }}
                      </div>
                    </div>

                    <!-- CUSTOMER -->
                    <div
                      v-if="
                        selectedCustomer && selectedCustomer.id !== undefined
                      "
                      style="width: 7.2%"
                      class="-text-right"
                    >
                      <div
                        v-if="
                          item.selling_conv_price === undefined ||
                          item.selling_conv_price[selectedCustomer.id] ==
                            null ||
                          item.selling_conv_price[selectedCustomer.id] === ''
                        "
                        style="visibility: hidden"
                      >
                        -
                        <!-- {{
                          showPoint(
                            formatNumber(
                              item.selling_conv_price[selectedCustomer.id],
                              2
                            ),
                            "front"
                          )
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(
                              item.selling_conv_price[selectedCustomer.id],
                              2
                            ),
                            "behind"
                          )
                        }}</span> -->
                      </div>
                      <!-- <div v-else style="visibility: hidden">-</div> -->
                      <div v-else style="display: inline">
                        {{
                          showPoint(
                            formatNumber(
                              item.selling_conv_price[selectedCustomer.id],
                              2
                            ),
                            "front"
                          )
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(
                              item.selling_conv_price[selectedCustomer.id],
                              2
                            ),
                            "behind"
                          )
                        }}</span>
                      </div>
                      <div
                        v-if="slcSearch == 0"
                        :class="
                          classPercent(item.selling_conv_price, 2, 'customer')
                        "
                      >
                        {{
                          calPercent(item.selling_conv_price, 2, "customer")
                        }}%
                      </div>
                      <div
                        v-else-if="slcSearch == 1"
                        :class="item.price.B1 < 0 ? '-bgred' : '-percent'"
                      >
                        {{ formatNumber(item.price[selectedCustomer.id], 2) }}
                      </div>
                    </div>

                    <!-- COMPARE 1 -->
                    <div
                      v-show="customer1 !== ''"
                      style="width: 7.2%"
                      class="-text-right"
                    >
                      <div
                        v-if="item.compare_cus1 != ''"
                        style="display: inline"
                      >
                        {{
                          showPoint(formatNumber(item.compare_cus1, 2), "front")
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(item.compare_cus1, 2),
                            "behind"
                          )
                        }}</span>
                      </div>
                      <div v-else style="visibility: hidden">-</div>

                      <div
                        v-if="slcSearch == 0"
                        :class="
                          classPercent(
                            item.selling_conv_price,
                            2,
                            '',
                            item.compare_cus1
                          )
                        "
                      >
                        {{
                          calPercent(
                            item.selling_conv_price,
                            2,
                            "",
                            item.compare_cus1
                          )
                        }}%
                      </div>
                      <div
                        v-else-if="slcSearch == 1"
                        :class="item.compare_cus1 < 0 ? '-bgred' : '-percent'"
                      >
                        {{ formatNumber(item.compare_cus1, 2) }}
                      </div>
                    </div>

                    <!-- COMPARE 2 -->
                    <div
                      v-show="customer2 !== ''"
                      style="width: 7.2%"
                      class="-text-right"
                    >
                      <div
                        v-if="item.compare_cus2 != ''"
                        style="display: inline"
                      >
                        {{
                          showPoint(formatNumber(item.compare_cus2, 2), "front")
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(item.compare_cus2, 2),
                            "behind"
                          )
                        }}</span>
                      </div>
                      <div v-else style="visibility: hidden">-</div>

                      <div
                        v-if="slcSearch == 0"
                        :class="
                          classPercent(
                            item.selling_conv_price,
                            2,
                            '',
                            item.compare_cus2
                          )
                        "
                      >
                        {{
                          calPercent(
                            item.selling_conv_price,
                            2,
                            "",
                            item.compare_cus2
                          )
                        }}%
                      </div>
                      <div
                        v-else-if="slcSearch == 1"
                        :class="item.compare_cus2 < 0 ? '-bgred' : '-percent'"
                      >
                        {{ formatNumber(item.compare_cus2, 2) }}
                      </div>
                    </div>

                    <!-- COMPARE 3 -->
                    <div
                      v-show="customer3 !== ''"
                      style="width: 7.2%"
                      class="-text-right"
                    >
                      <div
                        v-if="item.compare_cus3 != ''"
                        style="display: inline"
                      >
                        {{
                          showPoint(formatNumber(item.compare_cus3, 2), "front")
                        }}
                        <span style="font-size: 11px">{{
                          showPoint(
                            formatNumber(item.compare_cus3, 2),
                            "behind"
                          )
                        }}</span>
                      </div>
                      <div v-else style="visibility: hidden">-</div>

                      <div
                        v-if="slcSearch == 0"
                        :class="
                          classPercent(
                            item.selling_conv_price,
                            2,
                            '',
                            item.compare_cus3
                          )
                        "
                      >
                        {{
                          calPercent(
                            item.selling_conv_price,
                            2,
                            "",
                            item.compare_cus3
                          )
                        }}%
                      </div>
                      <div
                        v-else-if="slcSearch == 1"
                        :class="item.compare_cus3 < 0 ? '-bgred' : '-percent'"
                      >
                        {{ formatNumber(item.compare_cus3, 2) }}
                      </div>
                    </div>

                    <!-- EFFECTIVE DATE -->
                    <div style="width: 7.5%" class="-text-center">
                      {{
                        item.effective_date === null ||
                        item.effective_date === ""
                          ? ""
                          : formatDate(item.effective_date)
                      }}
                    </div>

                    <!-- EXPIRE DATE -->
                    <div style="width: 6.5%" class="-text-center">
                      {{
                        item.expire_date === null || item.expire_date === ""
                          ? ""
                          : formatDate(item.expire_date)
                      }}
                    </div>

                    <div
                      style="width: 2%; cursor: pointer"
                      @click="openDailogHistory(item)"
                    >
                      <md-icon title="Price History">more_vert</md-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- v-if="filterdata == true" -->
            <!-- :dataCustomer="allCustomerBookPrice" -->
            <BookpriceDialogFilter
              :valueTab="valueTab"
              :show="filterdata"
              :customer="setDataCustomer"
              :customer1="setDataCustomer1"
              :customer2="setDataCustomer2"
              :customer3="setDataCustomer3"
              :dataType="setDataType"
              :dataGroup="setDataGroup"
              :dataSubGroup="setDataSubGroup"
              :dataCg="setDataCg"
              ref="bookpriceDialogFilter"
              :vSearch="vSearch"
              :vFilter="vFilter"
              :typeAll="typeAll"
              @clickFilter="onClickFilter"
              @clickCancel="onClickCancel"
            ></BookpriceDialogFilter>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <BookpriceDialogHistory
      :show="showHistory"
      :selectedRow="selectedRow"
      :bookGroup="bookGroup"
      :slcSearch="slcSearch"
      @close="closeDialogHistory"
    ></BookpriceDialogHistory>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import BookpriceDialogFilter from "./../../pricing/bookprice/bookprice-dialog-filter";
import BookpriceDialogHistory from "./../../pricing/bookprice/bookprice-dialog-history";
import PricingService from "@/services/pricing";
import GlobalService from "@/services/global_function";
import BookpriceService from "@/services/bookprice";
import Vue from "vue";
import axios from 'axios';

export default {
  name: "tab-bookprice-list",

  props: {
    changeTab: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    BookpriceDialogFilter: BookpriceDialogFilter,
    BookpriceDialogHistory: BookpriceDialogHistory,
  },

  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isExport() {
      if (this.permit.acl["overview"].menus["book-price"]) {
        return this.permit.acl["overview"].menus["book-price"].export;
      }
      return false;
    },
  },

  created() {
    this.dataToken = this.$jwt.decode(localStorage.getItem("token"));
    this.bookPrice = JSON.parse(localStorage.getItem("click_book_price"));
    if (
      this.bookPrice !== null ||
      (this.selectedCustomer && this.selectedCustomer.id !== undefined)
    ) {
      this.bookGroup = this.bookPrice;
      this.getDataList("clear");
    }
  },

  watch: {
    changeTab() {
      this.searchKeyword = "";
      //     if (this.changeTab) {
      //       this.bookPrice = null;
      //       this.selectedCustomer = {};
      //       this.countDataAll = 0;
      //       this.countDataUpcoming = 0;
      //       this.clearAllData();
      //       this.getDataList("clear");
      //     }
    },
  },

  data() {
    return {
      loadData: false,
      slcSearch: 0,
      status: ["% Increase on selling unit", "Stocking unit"],
      titleSearch: "Click to change search by item code",
      vSearch: "",
      placeholderSearch: "Search Product Code...",
      vChipsFilter: [],
      vFilter: [],
      scroll_start: [0],
      filterdata: false,
      tbBookpriceList: [],
      valueTab: "ALL",
      typeAll: [],
      bookPrice: [],
      dataCompareCustomer: [],
      customer1: "",
      customer1Title: "",
      customer2: "",
      customer2Title: "",
      customer3: "",
      customer3Title: "",
      checkSearch: 0,
      searchKeyword: "",
      startLoadData: 0,
      setDataCustomer: {},
      setDataCustomer1: {},
      setDataCustomer2: {},
      setDataCustomer3: {},
      setDataType: {},
      setDataGroup: {},
      setDataSubGroup: {},
      setDataCg: {},
      countDataAll: 0,
      countDataUpcoming: 0,
      dataPopupFilter: [],
      selectedCustomer: {},
      dContent: "",
      showSnackbar: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      loadExport: false,
      showHistory: false,
      selectedRow: {},
      bookGroup: {},
      cancelTokenSource: null,
      cancelTokenSourceCountData: null
    };
  },

  methods: {
    labelTitle(customer, title) {
      return customer + " : " + title;
    },
    displayFilter(items) {
      if (items.type === "type") {
        return "TYPE. [" + items.code + "]";
      } else if (items.type === "group") {
        return "GROUP. [" + items.code + "]";
      } else if (items.type === "subGroup") {
        return "SUBGROUP. [" + items.code + "]";
      } else if (items.type === "cg") {
        return "CG. [" + items.code + "]";
      }
    },
    clearAllData() {
      this.scroll_start = [0];
      this.tbBookpriceList = [];
      // this.searchKeyword = "";
      this.startLoadData = 0;
      this.dataCompareCustomer = [];
      this.customer1 = "";
      this.setDataCustomer1 = {};
      this.customer2 = "";
      this.setDataCustomer2 = {};
      this.customer3 = "";
      this.setDataCustomer3 = {};
      this.vChipsFilter = [];

      this.setDataType = {};
      this.setDataGroup = {};
      this.setDataSubGroup = {};
      this.setDataCg = {};
      this.dataPopupFilter.type = [];
      this.dataPopupFilter.group = [];
      this.dataPopupFilter.subGroup = [];
      this.dataPopupFilter.cg = [];
    },
    onClickTab(value) {
      this.valueTab = value;
      this.clearAllData();
      this.getDataList("clear");
    },
    formatNumber(value, dicimal) {
      return PricingService.formatNumber(value, dicimal);
    },
    formatDate(date) {
      if (date !== undefined) {
        return GlobalService.formatDate(date, "DD/MM/YYYY");
      } else {
        return "";
      }
    },
    async countDataTab() {
      // ยกเลิก request ก่อนหน้าถ้ามี
      if (this.cancelTokenSourceCountData) {
        this.cancelTokenSourceCountData.cancel('Operation canceled due to new request.');
      }
      // สร้าง cancel token ใหม่
      this.cancelTokenSourceCountData = axios.CancelToken.source();
      
      try {
        let code_value = "";
        // let type_value = "";
        if (this.bookPrice !== null) {
          // type_value = false;
          code_value = this.bookPrice.code;
        } else if (
          this.selectedCustomer &&
          this.selectedCustomer.id !== undefined
        ) {
          // type_value = true;
          code_value = this.selectedCustomer.id;
        }
        await BookpriceService.countViewBook({
          code: code_value,
          // type: type_value
        }, this.cancelTokenSourceCountData.token).then((response) => {
          this.countDataAll = response.data.count_all;
          this.countDataUpcoming = response.data.count_upcoming;
        });
      } catch (error) {
        if (axios.isCancel(error)) {
          // console.log('Previous request canceled');
        } else {
          // handle error
          console.error(error);
        }
      }
    },
    async getDataList(type, typeExport) {
      // ยกเลิก request ก่อนหน้าถ้ามี
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Operation canceled due to new request.');
      }
      // สร้าง cancel token ใหม่
      this.cancelTokenSource = axios.CancelToken.source();

      try {
        if (
          this.bookPrice !== null ||
          (this.selectedCustomer && this.selectedCustomer.id !== undefined)
        ) {
          let customerCompare = "";
          if (this.dataCompareCustomer.length > 0) {
            this.dataCompareCustomer.forEach(function (item) {
              if (item.id !== undefined) {
                customerCompare += item.id + ",";
              }
            });
          }

          this.loadData = true;
          this.checkKeyword = this.searchKeyword;

          let typeSearch =
            this.dataPopupFilter.type && this.dataPopupFilter.type.code
              ? this.dataPopupFilter.type.code
              : "";
          let groupSearch =
            this.dataPopupFilter.group && this.dataPopupFilter.group.code
              ? this.dataPopupFilter.group.code
              : "";
          let subGroupSearch =
            this.dataPopupFilter.subGroup && this.dataPopupFilter.subGroup.code
              ? this.dataPopupFilter.subGroup.code
              : "";
          let CgSearch =
            this.dataPopupFilter.cg && this.dataPopupFilter.cg.code
              ? this.dataPopupFilter.cg.code
              : "";

          let groupbookCode = "";
          if (this.bookPrice !== null) {
            groupbookCode = this.bookPrice.code;
          } else if (
            this.selectedCustomer &&
            this.selectedCustomer.id !== undefined
          ) {
            groupbookCode = this.selectedCustomer.id;
          }

          let datas = {
            tab: this.valueTab,
            keyword: this.searchKeyword,
            emp_code: this.dataToken.code,
            groupbook_code: groupbookCode,
            // groupbook_code: this.bookPrice !== null ? this.bookPrice.code : "",
            // customer:
            //   this.selectedCustomer && this.selectedCustomer.id !== undefined
            //     ? this.selectedCustomer.id
            //     : "",
            customer_compare:
              customerCompare !== ""
                ? customerCompare.substring(0, customerCompare.length - 1)
                : "",
            search: this.checkSearch === 0 ? "code" : "name",
            type: typeSearch,
            group: groupSearch,
            sub_group: subGroupSearch,
            cg: CgSearch,
            type_export: typeExport,
            start: typeExport === "export" ? 0 : this.startLoadData,
            limit: typeExport === "export" ? 9999 : 30,
          };

          this.countDataTab();

          await BookpriceService.getViewBookPrice(datas, null, this.cancelTokenSource.token)
            .then((response) => {
              response.sort((a, b) => (a.code > b.code ? 1 : -1));
              if (typeExport === "export") {
                this.setDataExcel(response);
              } else {
                this.setDataTable(response, type);
              }
              this.loadData = false;
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status == "404") {
                  this.tbBookpriceList = [];
                  this.dContent = error.response.data.message;
                  this.showSnackbar = true;
                  this.loadData = false;
                  return;
                }
              }
            });
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          // console.log('Previous request canceled');
        } else {
          // handle error
          console.error(error);
        }
      }
    },
    setDataTable(datas, type) {
      let self = this;
      if (self.tbBookpriceList.length > 0 && type !== "clear") {
        //-- have data in table --//
        if (self.dataCompareCustomer.length > 0 && datas.length > 0) {
          self.setPriceCompareCustomer(datas);
        } else {
          //-- scrollbar --//
          datas.forEach(function (item) {
            self.tbBookpriceList.push(item);
          });
        }
      } else {
        //-- first time or clear data --//
        if (
          self.dataCompareCustomer.length > 0 &&
          datas.length > 0 &&
          type !== "clear"
        ) {
          self.setPriceCompareCustomer(datas);
        } else {
          // self.tbBookpriceList = datas;
          self.tbBookpriceList = [];
          self.setPriceCompareCustomer(datas);
        }
      }
    },
    setPriceCompareCustomer(datas) {
      //-- have data compare customer --//
      let self = this;
      datas.forEach(function (item) {
        self.tbBookpriceList.push(item);
      });

      self.tbBookpriceList.forEach(function (data, index) {
        let dataComp1 = self.dataCompareCustomer[0]
          ? self.dataCompareCustomer[0].id
          : "";
        let priceComp1 =
          data.selling_conv_price !== undefined && data.selling_conv_price[dataComp1] !== undefined
            ? data.selling_conv_price[dataComp1]
            : "";
        Vue.set(self.tbBookpriceList[index], "compare_cus1", priceComp1);

        let dataComp2 = self.dataCompareCustomer[1]
          ? self.dataCompareCustomer[1].id
          : "";
        let priceComp2 =
          data.selling_conv_price !== undefined && data.selling_conv_price[dataComp2] !== undefined
            ? data.selling_conv_price[dataComp2]
            : "";
        Vue.set(self.tbBookpriceList[index], "compare_cus2", priceComp2);

        let dataComp3 = self.dataCompareCustomer[2]
          ? self.dataCompareCustomer[2].id
          : "";
        let priceComp3 =
          data.selling_conv_price !== undefined && data.selling_conv_price[dataComp3] !== undefined
            ? data.selling_conv_price[dataComp3]
            : "";
        Vue.set(self.tbBookpriceList[index], "compare_cus3", priceComp3);
      });
    },
    setStyle(slcCondition) {
      // let width = 7.2;
      // let num = width * checkCompare;
      // let widthSlc0 = 0;
      // let widthSlc1 = 0;

      // if (
      //   this.tbBookpriceList["customer"] &&
      //   this.tbBookpriceList["customer"].id !== undefined
      // ) {
      //   widthSlc0 = checkCompare === 0 ? 41.8 : 41.8 - num;
      //   widthSlc1 = checkCompare === 0 ? 35.8 : 35.8 - num;
      // } else {
      //   widthSlc0 = checkCompare === 0 ? 49 : 49 - num;
      //   widthSlc1 = checkCompare === 0 ? 43 : 43 - num;
      // }

      if (slcCondition === 0) {
        if (
          this.customer1 !== "" &&
          this.customer2 !== "" &&
          this.customer3 !== ""
        ) {
          return "width: 20.2%;";
        } else if (
          this.customer1 === "" &&
          this.customer2 === "" &&
          this.customer3 === ""
        ) {
          return "width: 41.8%;";
        } else if (
          (this.customer1 !== "" && this.customer2 !== "") ||
          (this.customer1 !== "" && this.customer3 !== "") ||
          (this.customer2 !== "" && this.customer3 !== "")
        ) {
          return "width: 27.4%;";
        } else if (
          this.customer1 !== "" ||
          this.customer2 !== "" ||
          this.customer3 !== ""
        ) {
          return "width: 34.6%;";
        }
      } else if (slcCondition === 1) {
        if (
          this.customer1 !== "" &&
          this.customer2 !== "" &&
          this.customer3 !== ""
        ) {
          return "width: 14.2%;";
        } else if (
          this.customer1 === "" &&
          this.customer2 === "" &&
          this.customer3 === ""
        ) {
          return "width: 35.8%;";
        } else if (this.customer1 !== "" && this.customer2 !== "") {
          return "width: 21.4%;";
        } else if (this.customer1 !== "") {
          return "width: 28.6%;";
        }
      }
    },
    showPoint(value, pos) {
      return PricingService.showPoint(value, pos);
    },
    calPercent(price, pos, column, priceCusComp) {
      let priceA3 = 0;
      let percent = 0;

      if (price !== undefined) {
        if (column === "C0") {
          let priceC0 = price.C0 && price.C0 !== "" ? price.C0 : 0;
          priceA3 = price.A3 && price.A3 !== "" ? price.A3 : 0;
          if (parseFloat(priceC0) === 0 || parseFloat(priceA3) === 0) {
            percent = 0;
          } else {
            // percent =
            //   ((parseFloat(priceC0) - parseFloat(priceA3)) /
            //     parseFloat(priceC0)) *
            //   100;
            percent =
              ((parseFloat(priceC0) - parseFloat(priceA3)) /
                parseFloat(priceA3)) *
              100;
          }
        } else if (column === "SS") {
          let priceSS = price.SS && price.SS !== "" ? price.SS : 0;

          priceA3 = price.A3 && price.A3 !== "" ? price.A3 : 0;
          if (parseFloat(priceSS) === 0 || parseFloat(priceA3) === 0) {
            percent = 0;
          } else {
            // percent =
            //   ((parseFloat(priceSS) - parseFloat(priceA3)) /
            //     parseFloat(priceSS)) *
            //   100;
            percent =
              ((parseFloat(priceSS) - parseFloat(priceA3)) /
                parseFloat(priceA3)) *
              100;
          }
        } else if (column === "bookcode" || column === "customer") {
          let priceType = "";
          let priceB = 0;

          if (this.bookPrice !== null) {
            priceType = this.bookPrice.code;
            // priceB =
            //   price[priceType] && price[priceType] !== "" ? price[priceType] : 0;
          } else {
            priceType = this.selectedCustomer.id;
          }
          priceB =
            price[priceType] && price[priceType] !== "" ? price[priceType] : 0;

          priceA3 = price.A3 && price.A3 !== "" ? price.A3 : 0;
          if (parseFloat(priceB) === 0 || parseFloat(priceA3) === 0) {
            percent = 0;
          } else {
            percent =
              ((parseFloat(priceB) - parseFloat(priceA3)) /
                parseFloat(priceA3)) *
              100;
          }
        } else {
          let priceComp =
            priceCusComp && priceCusComp !== "" ? priceCusComp : 0;
          priceA3 = price.A3 && price.A3 !== "" ? price.A3 : 0;

          if (parseFloat(priceComp) === 0 || parseFloat(priceA3) === 0) {
            percent = 0;
          } else {
            percent =
              ((parseFloat(priceComp) - parseFloat(priceA3)) /
                parseFloat(priceA3)) *
              100;
          }
        }
      }

      return PricingService.formatNumber(percent, pos);
    },
    classPercent(price, pos, column, priceCusComp) {
      let value = this.calPercent(price, pos, column, priceCusComp);
      if (parseFloat(value) >= 0) {
        return "-percent";
      } else {
        return "-bgred";
      }
    },
    selectSearch() {
      this.checkSearch++;
      if (this.checkSearch == 1) {
        this.placeholderSearch = "Search Product Name...";
        this.titleSearch = "Click to change search by item code";
      } else {
        this.placeholderSearch = "Search Product Code...";
        this.titleSearch = "Click to change search by item name";
        this.checkSearch = 0;
      }

      this.scroll_start = [0];
      this.startLoadData = 0;
      this.getDataList("clear");
    },
    onChangeSearch() {
      this.scroll_start = [0];
      this.startLoadData = 0;
      this.getDataList("clear");
    },
    filterData() {
      this.setDataCustomer =
        this.selectedCustomer && this.selectedCustomer.length === 0
          ? {}
          : this.selectedCustomer;

      this.setDataCustomer1 =
        this.dataCompareCustomer[0] && this.dataCompareCustomer[0].length === 0
          ? {}
          : this.dataCompareCustomer[0];
      this.setDataCustomer2 =
        this.dataCompareCustomer[1] && this.dataCompareCustomer[1].length === 0
          ? {}
          : this.dataCompareCustomer[1];
      this.setDataCustomer3 =
        this.dataCompareCustomer[2] && this.dataCompareCustomer[2].length === 0
          ? {}
          : this.dataCompareCustomer[2];

      this.setDataType =
        this.dataPopupFilter.type && this.dataPopupFilter.type.code
          ? this.dataPopupFilter.type
          : {};
      this.setDataGroup =
        this.dataPopupFilter.group && this.dataPopupFilter.group.code
          ? this.dataPopupFilter.group
          : {};
      this.setDataSubGroup =
        this.dataPopupFilter.subGroup && this.dataPopupFilter.subGroup.code
          ? this.dataPopupFilter.subGroup
          : {};
      this.setDataCg =
        this.dataPopupFilter.cg && this.dataPopupFilter.cg.code
          ? this.dataPopupFilter.cg
          : {};
      this.filterdata = true;
    },
    handleScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight
      ) {
        if (!this.scroll_start.includes(this.tbBookpriceList.length)) {
          this.scroll_start.push(this.tbBookpriceList.length);
          this.startLoadData = this.tbBookpriceList.length;

          this.getDataList();
        } else {
          this.loadData = false;
        }
      }
    },
    onClickFilter(dataSearch) {
      // console.log("dataSearch ==>", dataSearch);
      /* CUSTOMER */
      // let checkLoadCompare = false;
      if (dataSearch.customer && dataSearch.customer.id) {
        this.bookPrice = null;
        localStorage.removeItem("click_book_price");
        this.selectedCustomer = dataSearch.customer;
        this.bookGroup = {
          code: dataSearch.customer.id,
          desc: dataSearch.customer.label,
        };
        // checkLoadCompare = true;
      } else {
        this.bookGroup = {};
        this.selectedCustomer = {};
      }

      this.dataPopupFilter = dataSearch;
      this.startLoadData = 0;

      // if (this.tbBookpriceList.length > 0) {
      this.dataCompareCustomer = dataSearch.customercomp;
      this.customer1 =
        this.dataCompareCustomer[0] &&
        this.dataCompareCustomer[0].id &&
        this.dataCompareCustomer[0].id !== ""
          ? this.dataCompareCustomer[0].id
          : "";
      this.customer1Title =
        this.dataCompareCustomer[0] &&
        this.dataCompareCustomer[0].label &&
        this.dataCompareCustomer[0].label !== ""
          ? this.dataCompareCustomer[0].label
          : "";
      this.customer2 =
        this.dataCompareCustomer[1] &&
        this.dataCompareCustomer[1].id &&
        this.dataCompareCustomer[1].id !== ""
          ? this.dataCompareCustomer[1].id
          : "";
      this.customer2Title =
        this.dataCompareCustomer[1] &&
        this.dataCompareCustomer[1].label &&
        this.dataCompareCustomer[1].label !== ""
          ? this.dataCompareCustomer[1].label
          : "";
      this.customer3 =
        this.dataCompareCustomer[2] &&
        this.dataCompareCustomer[2].id &&
        this.dataCompareCustomer[2].id !== ""
          ? this.dataCompareCustomer[2].id
          : "";
      this.customer3Title =
        this.dataCompareCustomer[2] &&
        this.dataCompareCustomer[2].label &&
        this.dataCompareCustomer[2].label !== ""
          ? this.dataCompareCustomer[2].label
          : "";

      // if (!checkLoadCompare) {
      //   this.loadDatacompareCustomer();
      // }

      this.vChipsFilter = [];

      /* CUSTOMER COMPARE */
      let self = this;
      if (dataSearch.customercomp.length > 0) {
        self.dataCompareCustomer.forEach(function (item) {
          self.vChipsFilter.push(item.id);
        });
      }

      /* PRODUCT */
      if (dataSearch.type && dataSearch.type.code) {
        this.vChipsFilter.push({
          code: dataSearch.type.code,
          title: dataSearch.type.title,
          type: "type",
        });
      }
      if (dataSearch.group && dataSearch.group.code) {
        this.vChipsFilter.push({
          code: dataSearch.group.code,
          title: dataSearch.group.title,
          type: "group",
        });
      }
      if (dataSearch.subGroup && dataSearch.subGroup.code) {
        this.vChipsFilter.push({
          code: dataSearch.subGroup.code,
          title: dataSearch.subGroup.title,
          type: "subGroup",
        });
      }
      if (dataSearch.cg && dataSearch.cg.code) {
        this.vChipsFilter.push({
          code: dataSearch.cg.code,
          title: dataSearch.cg.title,
          type: "cg",
        });
      }

      this.scroll_start = [0];
      this.startLoadData = 0;
      this.getDataList("clear");
      // }
      this.filterdata = false;
    },
    onClickCancel() {
      this.filterdata = false;
    },
    deleteDataSelected(type) {
      if (type === "groupbook") {
        this.bookPrice = null;
        this.bookGroup = {};
        localStorage.removeItem("click_book_price");
      } else {
        this.selectedCustomer = {};
        this.bookGroup = {};
      }
      this.scroll_start = [0];
      this.tbBookpriceList = [];
      this.valueTab = "ALL";
      this.searchKeyword = "";
      this.startLoadData = 0;
      this.dataCompareCustomer = [];
      this.vChipsFilter = [];
      this.countDataAll = 0;
      this.countDataUpcoming = 0;
      this.dataPopupFilter = [];
    },
    deleteFilter(items, index) {
      // console.log("items ==>", items);
      if (items === this.customer1) {
        this.customer1 = "";
        this.customer1Title = "";
        this.dataCompareCustomer[0] = [];
        this.setDataCustomer1 = {};
      } else if (items === this.customer2) {
        this.customer2 = "";
        this.customer2Title = "";
        this.dataCompareCustomer[1] = [];
        this.setDataCustomer2 = {};
      } else if (items === this.customer3) {
        this.customer3 = "";
        this.customer3Title = "";
        this.dataCompareCustomer[2] = [];
        this.setDataCustomer3 = {};
      }

      if (items.type == "type") {
        this.dataPopupFilter.type = [];
        this.setDataType = {};
        this.dataPopupFilter.group = [];
        this.setDataGroup = {};
        this.dataPopupFilter.subGroup = [];
        this.setDataSubGroup = {};
        this.dataPopupFilter.cg = [];
        this.setDataCg = {};
      } else if (items.type == "group") {
        this.dataPopupFilter.group = [];
        this.setDataGroup = {};
        this.dataPopupFilter.subGroup = [];
        this.setDataSubGroup = {};
        this.dataPopupFilter.cg = [];
        this.setDataCg = {};
      } else if (items.type == "subGroup") {
        this.dataPopupFilter.subGroup = [];
        this.setDataSubGroup = {};
        this.dataPopupFilter.cg = [];
        this.setDataCg = {};
      } else if (items.type == "cg") {
        this.dataPopupFilter.cg = [];
        this.setDataCg = {};
      }

      if (items.type === undefined) {
        this.vChipsFilter.splice(index, 1);
      } else {
        let tmpArr = [];
        for (let i = 0; i < this.vChipsFilter.length; i++) {
          if (i < index) {
            tmpArr.push(this.vChipsFilter[i]);
          }
        }
        this.vChipsFilter = tmpArr;
      }

      this.scroll_start = [0];
      this.startLoadData = 0;
      this.getDataList("clear");
    },
    export_excel() {
      // if (
      //   (this.dataPopupFilter.type === undefined ||
      //     this.dataPopupFilter.type == "") &&
      //   (this.dataPopupFilter.group === undefined ||
      //     this.dataPopupFilter.group == "") &&
      //   (this.dataPopupFilter.subGroup === undefined ||
      //     this.dataPopupFilter.subGroup == "") &&
      //   (this.dataPopupFilter.cg === undefined ||
      //     this.dataPopupFilter.cg == "") &&
      //   this.searchKeyword == ""
      // ) {
      //   this.dContent = "Please filter data.";
      //   this.showSnackbar = true;
      //   this.loadData = false;
      //   return false;
      // }
      if (this.bookPrice === null && this.selectedCustomer.id === undefined) {
        this.dContent = "Please select data.";
        this.showSnackbar = true;
        this.loadData = false;
        return false;
      }
      this.loadExport = true;
      this.getDataList("clear", "export");
    },
    setDataExcel(datas) {
      let self = this;
      let json_data = [];
      datas.forEach(function (item) {
        let itemName = item.title_th;
        if (
          item.title_th !== undefined &&
          item.title_th !== null &&
          item.title_th.indexOf(",") > -1
        ) {
          itemName = '"' + item.title_th + '"';
        }

        let obj = {};
        obj["Type"] =
          item.productype_code !== undefined ? "'" + item.productype_code : "";
        obj["Group"] =
          item.productgroup_code !== undefined
            ? "'" + item.productgroup_code
            : "";
        obj["Sub Group"] =
          item.productsubgroup_code !== undefined
            ? "'" + item.productsubgroup_code
            : "";
        obj["CG"] =
          item.productcg_code !== undefined ? "'" + item.productcg_code : "";
        obj["Item Code"] = "'" + item.code;
        obj["Item Name"] = itemName;
        obj["Cost"] =
          item.cost !== undefined && item.cost !== "" && item.cost !== null
            ? item.cost
            : "";
        obj["A3"] =
          item.selling_conv_price && item.selling_conv_price.A3 !== undefined
            ? item.selling_conv_price.A3
            : "";
        obj["C0"] =
          item.selling_conv_price && item.selling_conv_price.C0 !== undefined
            ? item.selling_conv_price.C0
            : "";
        obj["SS"] =
          item.selling_conv_price && item.selling_conv_price.SS !== undefined
            ? item.selling_conv_price.SS
            : "";

        if (self.bookPrice !== null) {
          obj[self.bookPrice.code] =
            item.selling_conv_price &&
            item.selling_conv_price[self.bookPrice.code] !== undefined
              ? item.selling_conv_price[self.bookPrice.code]
              : "";
        }

        if (self.selectedCustomer && self.selectedCustomer.id !== undefined) {
          let customer = "'" + self.selectedCustomer.id;
          obj[customer] =
            item.selling_conv_price &&
            item.selling_conv_price[self.selectedCustomer.id] !== undefined
              ? item.selling_conv_price[self.selectedCustomer.id]
              : "";
        }

        if (self.customer1 !== "") {
          let customerComp1 = "'" + self.customer1;
          obj[customerComp1] =
            item.selling_conv_price &&
            item.selling_conv_price[self.customer1] !== undefined
              ? item.selling_conv_price[self.customer1]
              : "";
        }
        if (self.customer2 !== "") {
          let customerComp2 = "'" + self.customer2;
          obj[customerComp2] =
            item.selling_conv_price &&
            item.selling_conv_price[self.customer2] !== undefined
              ? item.selling_conv_price[self.customer2]
              : "";
        }
        if (self.customer3 !== "") {
          let customerComp3 = "'" + self.customer3;
          obj[customerComp3] =
            item.selling_conv_price &&
            item.selling_conv_price[self.customer3] !== undefined
              ? item.selling_conv_price[self.customer3]
              : "";
        }

        obj["Effective Date"] =
          item.effective_date !== undefined
            ? self.formatDate(item.effective_date)
            : "";
        obj["Expire Date"] =
          item.expire_date !== undefined
            ? self.formatDate(item.expire_date)
            : "";

        json_data.push(obj);
      });

      if (json_data.length > 0) {
        self.JSONToCSVConvertor(json_data, "Product on Selling ViewBook_");
      } else {
        this.dContent = "Please select data for export.";
        this.showSnackbar = true;
      }
      this.loadExport = false;
    },
    JSONToCSVConvertor(JSONData, ReportTitle) {
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      var CSV = "";
      var row = "";
      for (var index in arrData[0]) {
        row += index + ",";
      }

      row = row.slice(0, -1);
      CSV += row + "\r\n";

      for (var i = 0; i < arrData.length; i++) {
        let row = "";
        for (let index in arrData[i]) {
          row += arrData[i][index] + ",";
        }

        row.slice(0, row.length - 1);
        CSV += row + "\r\n";
      }

      if (CSV == "") {
        alert("Invalid data");
        return;
      }

      var d = new Date();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var currentDate =
        d.getFullYear() +
        (month < 10 ? "0" : "") +
        month +
        (day < 10 ? "0" : "") +
        day;

      var fileName = ReportTitle + currentDate;
      var uri =
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(CSV);
      var link = document.createElement("a");
      link.href = uri;
      link.style = "visibility:hidden";
      link.download = fileName + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    openDailogHistory(value) {
      this.selectedRow = value;
      this.showHistory = true;
    },
    closeDialogHistory() {
      this.showHistory = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.bookprice-page {
  .tab-chip {
    &.delete {
      margin-left: 5px;
    }
    &.-chiplightgray {
      margin-right: 5px;
      background-color: #bebfbf;
    }
    &.-colorgray {
      margin-left: 5px;
      background-color: #969696 !important;
    }
  }

  #table-bookprice-list {
    #divHeadList {
      width: 99.3% !important;
    }
  }
}
</style>